import Vue from 'vue'
import App from '@/App.vue'
import router from '@Base/router'
import store from '@Base/store'

// Fonts
import '@mdi/font/css/materialdesignicons.css';

// Plugins
import vuetify from '@Base/plugins/vuetify';
import i18n from '@Base/plugins/i18n.js';
//import '@Base/plugins/vyrianComponents.js';
import '@Base/plugins/showMessage-prototype';
// Tailwind
//import '@Base/assets/tailwind.css'

Vue.config.productionTip = false;
Vue.prototype.$appVersion = process.env.APP_VERSION;

const vue = new Vue({
	router,
	store,
	vuetify,
	i18n,
	render: h => h(App)
}).$mount('#app');


if (window.addEventListener) {
  // For standards-compliant web browsers
  window.addEventListener("message", processWrapperMessage, false);
} else {
  window.attachEvent("onmessage", processWrapperMessage);
}

function processWrapperMessage (msg) {
  if (msg.data==='PDF:START')
    vue.$store.commit('solicitud/setPdfCargado',true);

    if (msg.data==='PDF:END')
    vue.$store.commit('solicitud/setPdfCompletado',true);
}

window.$vue = vue; // Con esto conseguimos poder acceder a la instancia desde cualquier punto
window.$store = store;
